"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMaskContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _LoadingMaskContent = require("./LoadingMaskContent.styles");
/**
 * @since 8.1.0
 */
var LoadingMaskContent = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_LoadingMaskContent.StyledLoadingMaskContent, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.LoadingMaskContent = LoadingMaskContent;
LoadingMaskContent.displayName = 'LoadingMaskContent';